import { render } from "./UnauthorizedPage.vue?vue&type=template&id=f2ec17fc&ts=true"
import script from "./UnauthorizedPage.vue?vue&type=script&lang=ts"
export * from "./UnauthorizedPage.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/end-vue_us_qa_azure_v24042026_02/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__